import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';

import uuid from 'uuid/v1';

import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

import {
  Box,
  Button,
  Checkbox,
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField
} from '@mui/material';

import DescriptionIcon from '@mui/icons-material/Description';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedViewLinksField = props => {
  const {
    listComponentsAdvanced,
    settingsAdvanced,
    setListComponentsAdvanced,
    setSettingsAdvanced
  } = props;
  const itemsPerPage = 5;
  const [name, setName] = React.useState('');
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.ViewLinksComponent.name
  );
  const [viewLinksState, setViewLinksState] = React.useState(settingsAdvanced.viewLinks);
  const [page, setPage] = React.useState(1);
  const [type, setType] = React.useState('url');
  const [value, setValue] = React.useState('');
  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const [openModal, setOpenModal] = React.useState(false);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.ViewLinksComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.ViewLinksComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.ViewLinksComponent.libraryIcon
  );

  const handleIconSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setIconFontawesome(elementIcon);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ViewLinksComponent: {
          name: listComponentsAdvanced.ViewLinksComponent.name,
          show: listComponentsAdvanced.ViewLinksComponent.show,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
    }

    if (library === LIBRARY_ICON_TYPES.SVG) {
      setIconSvg(elementIcon.url);
      setIconFontawesome(elementIcon.name);
      setListComponentsAdvanced({
        ...listComponentsAdvanced,
        ViewLinksComponent: {
          name: listComponentsAdvanced.ViewLinksComponent.name,
          show: listComponentsAdvanced.ViewLinksComponent.show,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
    }
    setLibraryIcon(library);
  };

  const handleChangeValue = event => {
    setValue(event.target.value);
  };
  const getLabel = () => {
    if (type === 'url') {
      return 'Introduce una URL';
    }
    if (type === 'html') {
      return 'Introduce un HTML';
    }
    return '';
  };

  const isValidURL = urlString => {
    const patronURL = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return !!patronURL.test(urlString);
  };
  const handleAddLink = () => {
    const newLink = { name, type, value };
    const isValid = (type === 'url' && isValidURL(value)) || type === 'html';
    if (isValid) {
      const newViewLinksState = [...viewLinksState, newLink];
      setSettingsAdvanced(prevSettings => ({
        ...prevSettings,
        viewLinks: newViewLinksState
      }));
      setViewLinksState(newViewLinksState);
      setValue('');
      setName('');
    } else {
      Bert.alert('URL NOT VALID', 'danger');
    }
  };

  const handleDeleteLink = index => {
    const newViewLinksState = viewLinksState.filter((_, i) => i !== index);
    setSettingsAdvanced(prevSettings => ({
      ...prevSettings,
      viewLinks: newViewLinksState
    }));
    setViewLinksState(newViewLinksState);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Box display="column" width="50%" gab={1}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          mb: 2,
          width: '100%'
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          id="outlined-required"
          label="Nombre del componente"
          size="small"
          value={nameComponent}
          onChange={event => setNameComponent(event.target.value)}
          mb={2}
          fullWidth
        />
        <IconButton
          onClick={() => setOpenModal(true)}
          style={{
            color: '#2A3F90'
          }}
        >
          {!isEmpty(libraryIcon) ? (
            <>
              {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                <FontAwesomeIcon icon={iconFontawesome} />
              )}
              {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                <img
                  src={iconSvg}
                  alt={iconFontawesome}
                  style={{ marginRight: '5px', width: '20px', height: '20px' }}
                />
              )}
            </>
          ) : (
            <DescriptionIcon />
          )}
        </IconButton>
        <IconButton
          onClick={() =>
            setListComponentsAdvanced({
              ...listComponentsAdvanced,
              ViewLinksComponent: {
                name: nameComponent,
                show: listComponentsAdvanced.ViewLinksComponent.show
              }
            })
          }
          style={{
            color: '#2A3F90'
          }}
        >
          <SaveIcon />
        </IconButton>
        <ShowListIconsFontawesome
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleIconSelected={handleIconSelected}
          selectedIcon={listComponentsAdvanced.ViewLinksComponent.iconFontawesome}
          startLibrary={listComponentsAdvanced.ViewLinksComponent.libraryIcon}
          svg={listComponentsAdvanced.ViewLinksComponent.iconSvg}
          startCategorySvg={listComponentsAdvanced.ViewLinksComponent.cetegorySvg}
        />
      </Box>
      <Box display="row" justifyContent="space-evenly" fullWidth mb={2}>
        <Checkbox
          checked={type === 'url'}
          onChange={event => {
            setType(event.target.value);
          }}
          sx={{
            color: '#2A3F90',
            '&.Mui-checked': {
              color: '#2A3F90'
            }
          }}
          value="url"
        />
        URL
        <Checkbox
          checked={type === 'html'}
          onChange={event => {
            setType(event.target.value);
          }}
          sx={{
            color: '#2A3F90',
            '&.Mui-checked': {
              color: '#2A3F90'
            }
          }}
          value="html"
        />
        HTML
      </Box>
      <TextField
        id="outlined-required"
        label={getLabel()}
        size="small"
        value={value}
        onChange={handleChangeValue}
        fullWidth
        mb={2}
      />
      <TextField
        id="outlined-required"
        label="Introduce un nombre"
        size="small"
        value={name}
        onChange={event => {
          setName(event.target.value);
        }}
        fullWidth
        mb={2}
      />
      <Button variant="contained" color="success" onClick={handleAddLink}>
        Añadir
      </Button>
      <Table>
        <TableBody>
          {viewLinksState.slice(startIndex, endIndex).map((item, index) => (
            <TableRow key={uuid()}>
              <TableCell>{item.name}</TableCell>
              <TableCell>
                <IconButton
                  size="small"
                  onClick={() => handleDeleteLink(startIndex + index)}
                  sx={{
                    color: '#2A3F90'
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Stack
        direction="row"
        spacing={2}
        sx={{
          marginTop: '20px',
          justifyContent: 'center'
        }}
      >
        <Pagination
          count={Math.ceil(viewLinksState.length / itemsPerPage)}
          page={page}
          onChange={handleChangePage}
          sx={{
            '& .MuiPaginationItem-page.Mui-selected': {
              backgroundColor: '#2A3F90',
              color: 'white'
            },
            '& .MuiPaginationItem-page.Mui-selected .MuiPaginationItem-pageNumber': {
              color: 'white'
            }
          }}
        />
      </Stack>
    </Box>
  );
};
export default MapsAdvancedViewLinksField;
MapsAdvancedViewLinksField.defaultProps = {
  setListComponentsAdvanced: () => {}
};
MapsAdvancedViewLinksField.propTypes = {
  setSettingsAdvanced: PropTypes.func.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func
};
